import appStore from '../utils/state';

export default class AddGiftboxButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;

  private onClickBound = this.onClick.bind(this);

  connectedCallback(): void {
    this.button = this.querySelector('[data-add-giftbox-button-ref="button"]');

    this.addEventListeners();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
  }

  onClick(): void {
    appStore.actions.openGiftboxModal();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('add-giftbox-button', AddGiftboxButton);
